// El backend entrega los timestamps en hora del servidor (UTC) y, con
// frecuencia, SIN designador de zona (ej. "2026-07-22T19:52:08"). Al pasarlos a
// `new Date(...)` el navegador los interpreta como hora local, mostrando la hora
// del servidor (~5h adelante de Colombia). Aquí normalizamos: si la cadena no
// trae zona (Z o ±hh:mm), la tratamos como UTC agregando "Z", y luego formateamos
// en la zona local del navegador (la de quien consulta).

const HAS_TIMEZONE_RE = /(Z|[+-]\d{2}:?\d{2})$/;

// Devuelve un Date interpretando las cadenas "naive" (sin zona) como UTC.
export const parseServerDate = (value) => {
  if (value == null || value === "") return null;
  if (value instanceof Date) return value;

  let normalized = String(value).trim();
  // Cadena de fecha-hora ISO sin zona -> se asume UTC.
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(normalized) && !HAS_TIMEZONE_RE.test(normalized)) {
    normalized = `${normalized}Z`;
  }

  const date = new Date(normalized);
  return Number.isNaN(date.getTime()) ? null : date;
};

// Formatea un timestamp del servidor en la zona local del navegador. `options`
// acepta las mismas propiedades que Intl.DateTimeFormat (dateStyle, timeStyle,
// etc.); al no fijar `timeZone`, se usa la del equipo que consulta.
export const formatServerDate = (
  value,
  { fallback = "", ...options } = {}
) => {
  const date = parseServerDate(value);
  if (!date) return fallback;

  return new Intl.DateTimeFormat("es-CO", options).format(date);
};